import React from "react";
import "./ProductBox.css"; // Ensure this path is correct

const ProductBox = ({ product }) => {
  return (
    <div className="product-box bg-transparent text-white shadow-md p-6 rounded-[30px] border border-gray-500 w-72 transition duration-500 ease-in-out transform hover:scale-105 hover-gradient flex flex-col justify-between h-full">
      <div>
        <h3 className="text-lg font-semibold mb-4">{product.title}</h3>
        <ul
          className="list-none mb-4"
          style={{ direction: "ltr" }} // Apply LTR direction here
        >
          <li
            className="mb-2"
            dangerouslySetInnerHTML={{ __html: product.cpu }}
          ></li>
          <li
            className="mb-2"
            dangerouslySetInnerHTML={{ __html: product.ram }}
          ></li>
          <li
            className="mb-2"
            dangerouslySetInnerHTML={{ __html: product.disk }}
          ></li>
          <li
            className="mb-2"
            dangerouslySetInnerHTML={{ __html: product.traffic }}
          ></li>
          <li
            className="mb-2"
            dangerouslySetInnerHTML={{ __html: product.control_panel }}
          ></li>
        </ul>
      </div>
      <div className="mt-auto text-lg font-bold flex justify-between items-center">
        <div className="wrapperPrice text-[17px] sm:text-[14px]">
          <span className="p-1">
            {product.annually
              ? product.annually
              : product.monthly
              ? product.monthly
              : product.an_hour}
          </span>
          {product.currency.suffix}
        </div>

        <a
          href={product.slug}
          className="bg-blue-500 hover:bg-blue-600 text-black font-bold py-2 px-4 w-28 text-center purchase-button sm:mr-4 sm:w-32"
        >
          خرید
        </a>
      </div>
    </div>
  );
};

export default ProductBox;
